<template>
    <b-card :header="uLang('app.user_info')" header-tag="h4" class="latest-trajectory bg-default-card">
        <table class="user-info-table table">
            <tr>
                <td width="150">{{ uLang('app.title') }}:</td>
                <td>{{ uLang('app.' + user.title) }}</td>
            </tr>
            <tr>
                <td>{{ uLang('app.first_letters') }}:</td>
                <td>{{ user.first_letters ? user.first_letters : ''}}</td>
            </tr>
            <tr>
                <td>{{ uLang('app.first_name') }}:</td>
                <td>{{ user.first_name ? user.first_name : '' }}</td>
            </tr>
            <tr v-if="user.prefix">
                <td>{{ uLang('app.prefix') }}:</td>
                <td>{{ user.prefix }}</td>
            </tr>
            <tr>
                <td>{{ uLang('app.last_name') }}:</td>
                <td>{{ user.last_name }}</td>
            </tr>
            <tr>
                <td>{{ uLang('app.email') }}:</td>
                <td>{{ user.email }}</td>
            </tr>
            <tr v-if="user.full_phone_number">
                <td>{{ uLang('app.phone_number') }}:</td>
                <td>{{ user.full_phone_number }}</td>
            </tr>
            <tr v-if="user.full_mobile">
                <td>{{ uLang('app.mobile') }}:</td>
                <td>{{ user.full_mobile }}</td>
            </tr>
        </table>
    </b-card>
</template>
<script>
import { ReaLoader } from '~/components/helpers'
import { mapGetters } from 'vuex'

export default {
    name: 'UserInfo',

    components: {
        ReaLoader
    },

    computed: {
        ...mapGetters({
            'user': 'authUser'
        })
    }
}
</script>
<style lang="scss">
    table.user-info-table {
        tr:first-child {
            td {
                border-top: none;
            }
        }
        td {
            padding-left: 0px !important;
        }

    }

    .card-block {
        position: relative;
    }
</style>
